var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "d-flex mb-4" }, [
      _c("div", { staticClass: " flex-fill member-search-area" }, [
        _c("div", { staticClass: "d-flex search-text-area" }, [
          _c("div", { staticClass: "input-container" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.keyword,
                  expression: "keyword",
                },
              ],
              staticClass: "form-control input-search",
              attrs: {
                type: "text",
                placeholder: "Search for a company by their name...",
              },
              domProps: { value: _vm.keyword },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.keyword = $event.target.value
                  },
                  function ($event) {
                    _vm.isTyping = true
                  },
                ],
              },
            }),
            _vm._v(" "),
            _vm.keyword
              ? _c(
                  "button",
                  {
                    staticClass: "clear-button",
                    on: { click: _vm.clearInput },
                  },
                  [_vm._v("x")]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-right" }, [
          !this.unassignedFilter
            ? _c(
                "a",
                {
                  staticClass: "small",
                  on: {
                    click: function ($event) {
                      return _vm.filterByUnassigned()
                    },
                  },
                },
                [_vm._v("View Unassigned Companies")]
              )
            : _vm._e(),
          _vm._v(" "),
          this.unassignedFilter
            ? _c(
                "a",
                {
                  staticClass: "small",
                  on: {
                    click: function ($event) {
                      return _vm.filterByAssigned()
                    },
                  },
                },
                [_vm._v("View Assigned Companies")]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "scrollable-panel" },
      [
        _c(
          "div",
          { staticClass: "row match-height" },
          _vm._l(_vm.companies, function (company, index) {
            return _c(
              "div",
              { key: index, staticClass: "col-lg-12 col-md-12 col-sm-12" },
              [
                _c("company-directory-card", {
                  attrs: {
                    company: company,
                    organisationId: _vm.organisationId,
                    index: index,
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "infinite-loading",
          {
            attrs: { spinner: "spiral", identifier: _vm.infiniteId },
            on: {
              distance: function ($event) {
                1
              },
              infinite: _vm.infiniteHandler,
            },
          },
          [
            _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
            _vm._v(" "),
            _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }